import { AgreementStoreState } from "@/shared/interfaces/transaction/Agreement.interface";
import { Module, MutationTree } from "vuex";
import { RootState } from "../../store.interface";

const state: AgreementStoreState = {
    termsAndConditions: false,
};

const mutations: MutationTree<AgreementStoreState> = {
    termsAndConditions: function(state, agreement: boolean) {
        state.termsAndConditions = agreement;
    },
};

const agreement: Module<AgreementStoreState, RootState> = {
    namespaced: true,
    state: state,
    mutations: mutations,
};

export default agreement;
